export type LocalMedia = {
  type: 'local'
  url: string
  width?: number
  height?: number
  ratio?: number
  mime: string
}

export type ProfilePictureMedia = {
  type: 'profile-picture'
  variant: 'indoors' | 'outdoors' | 'avatar'
  zohoUserId: string
  transformations?: ImageTransformations
  name: string
}

export type MachineMedia = {
  type: 'machine'
  url: string
  mime: string
  attribute?: string
  width?: number
  height?: number
  ratio?: number
  alternativeText?: string
}

export type CmsMediaFileData = {
  data: CmsMediaFile | null
}

export type CmsMediaFile = {
  id: number
  attributes: {
    name: string
    alternativeText: string
    caption: string
    hash: string
    ext: string
    height: number
    mime: string
    url: string
    ratio?: number
  }
}

export type CmsMedia = {
  id: string
  videoUrl: string | null
  files: { data: CmsMediaFile[] | null }
  imageCaption?: string
}

export type Media =
  | LocalMedia
  | ProfilePictureMedia
  | MachineMedia
  | CmsMediaFile

export const isCmsMediaFile = (
  media: Media | CmsMedia
): media is CmsMediaFile => 'attributes' in media && 'id' in media

export const isCmsMedia = (media: Media | CmsMedia): media is CmsMedia =>
  'files' in media

export type ImageTransformations = Partial<{
  width: number
  height: number
  crop: string
  focus: string
  radius: number | 'max'
  zoom: number
  aspectRatio: string
  imageLayer: string
}>

const imageKitTransformationsKeysMapping: Record<
  keyof ImageTransformations,
  string
> = {
  crop: 'c',
  focus: 'fo',
  height: 'h',
  radius: 'r',
  width: 'w',
  zoom: 'z',
  aspectRatio: 'ar',
  imageLayer: 'l',
}

export const imageTransformationsToString = (
  transformations: ImageTransformations
) =>
  Object.entries(transformations)
    .map(
      ([key, value]) =>
        `${imageKitTransformationsKeysMapping[key as keyof ImageTransformations]}-${value}`
    )
    .join(',')
